// The four presentation tiers of the Actuals vs Budget report hierarchy, plus
// the rollup rows. Each tier gets its own row fill and label indent, so a reader
// can tell a cost centre from a budget line without following the chevrons.
//
// This is deliberately separate from the `level` prop the detailed table already
// passes: `level` is an indent depth and conflates tiers (a cost-centre rollup
// and a department's own budget lines both sit at level 1), whereas the fill and
// the indent are driven by what the row *is*.

export const ROW_DEPARTMENT = 'department';
export const ROW_COST_CENTRE = 'cost_centre';
export const ROW_PROJECT = 'project';
export const ROW_BUDGET_LINE = 'budget_line';
export const ROW_TOTAL = 'total';

export const DEFAULT_ROW_TYPE = ROW_BUDGET_LINE;
